export class ShowLoading {
  static readonly type = '[Loader] Show loading';
}

export class HideLoading {
  static readonly type = '[Loader] Hide loading';
}
